import { Component, OnInit } from '@angular/core';
import { APIService } from '../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatDialogRef } from '@angular/material/dialog';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss'],
  standalone: false,
})
export class LeadFormComponent implements OnInit {
  formData = {
    name: '',
    mobile: '',
    email: '',
    city: '',
    organizationName: '',
    totalStudents: null,
    days: '7',
  };

  constructor(
    private api: APIService,
    public deviceDetectorService: DeviceDetectorService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<LeadFormComponent>
  ) {}

  ngOnInit(): void {}
  isMobile(): boolean {
    // return (
    //   window.matchMedia(`(min-width: 200px)`).matches &&
    //   window.matchMedia(`(max-width: 800px)`).matches
    // );
    return this.deviceDetectorService.isMobile();
  }

  resetForm() {
    this.formData = {
      name: '',
      mobile: '',
      email: '',
      city: '',
      organizationName: '',
      totalStudents: null,
      days: '7',
    };
  }

  // submitDetails() {
  //   this.api.submitDemo(this.formData).subscribe((res) => {
  //     this.resetForm();
  //     this.dialogRef.close();
  //     this._snackBar.open("Your details saved successfully!", "")
  //   }, (err) => {
  //     // this.resetForm();
  //     this._snackBar.open("Your details not saved!", "")
  //     // this.dialogRef.close()
  //   })

  // }

  isNumber(val) {
    console.log('isNumber val', val);
    console.log('isNumber val', val, /^\d+$/.test(val + ''));
    if (val) return /^\d+$/.test(val + '');
    return false;
  }

  submitDetails() {
    if (!this.isNumber(this.formData.mobile)) {
      this._snackBar.open('Invalid mobile no!', 'OK', {
        duration: 6000,
      });
      return;
    }
    this.api.submitDemo(this.formData).subscribe(
      (res) => {
        this._snackBar.open('Your details are submitted!', '', {
          duration: 6000,
        });
        this.resetForm();
      },
      (err) => {
        this._snackBar.open('Your details are not submitted!', 'Resend', {
          duration: 6000,
        });
        this.resetForm();
      }
    );
  }
}
